import React from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { Panel, Link, LINK_VARIANT_EXTRALIGHT } from 'mailup-web-components'
import { useHistory } from 'react-router-dom'

import {
  mdCheckup,
  messageState
} from 'Pages/MessageCheckupSummary/recoil/state/message'

import CheckItem, {
  ICON_CHECK,
  ICON_INFO
} from 'Components/CheckItem/CheckItem'
import { EmailMessageCheckUpIssueType } from 'Constants/'
import { changeAlertCallback } from 'Pages/MessageCheckupSummary/recoil/callbacks/callbacks'
import { CUSTOM_DOMAIN_NOT_CUSTOMIZABLE } from 'Constants/index'
import { notifyParent } from 'mailup-react-helpers'

const ImprovementsDetails = () => {
  const intl = useIntl()
  const history = useHistory()

  const {
    id,
    checkup: {
      improvementsIssues: { Preheader, WebAnalytics, DomainCustomizable },
      domainCustomizableStatus
    }
  } = useRecoilValue(messageState)

  const [{ silencedAlertsArray }, setMdState] = useRecoilState(mdCheckup)

  const changeAlert = useRecoilCallback(changeAlertCallback, [])

  const handleGoToOverview = () => {
    history.push(`/messages/email/${id}/overview?source=all&op=mod`)
  }

  const handleGoToOverviewAtLinkTracking = () => {
    history.push(
      `/messages/email/${id}/overview?source=all&op=mod&scrollTo=link_tracking`
    )
  }

  return (
    <Panel>
      {Preheader ? (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e => e.issueType === EmailMessageCheckUpIssueType.PreheaderInfo
            ).silenced
          }
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.PreheaderInfo,
              e.toLowerCase()
            )
          }
          icon={ICON_INFO}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.PreheaderInfoKoTitle'
          })}
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.PreheaderInfoKoDesc'
            },
            {
              link: chunks => (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  key={chunks}
                  onClick={handleGoToOverview}
                >
                  {chunks}
                </Link>
              )
            }
          )}
          data-mu-test='improvements-details__preheader--ko'
        />
      ) : (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e => e.issueType === EmailMessageCheckUpIssueType.PreheaderInfo
            ).silenced
          }
          icon={ICON_CHECK}
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.PreheaderInfo,
              e.toLowerCase()
            )
          }
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.PreheaderInfoOkTitle'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailCheckUp.PreheaderInfoOkDesc'
          })}
          data-mu-test='improvements-details__preheader--ok'
        />
      )}

      {WebAnalytics ? (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e =>
                e.issueType ===
                EmailMessageCheckUpIssueType.WebAnalyticsTrackingInfo
            ).silenced
          }
          icon={ICON_INFO}
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.WebAnalyticsTrackingInfo,
              e.toLowerCase()
            )
          }
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.WebAnalyticsTrackingInfoKoTitle'
          })}
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.WebAnalyticsTrackingInfoKoDesc'
            },
            {
              link: chunks => (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  key={chunks}
                  onClick={handleGoToOverviewAtLinkTracking}
                >
                  {chunks}
                </Link>
              )
            }
          )}
          data-mu-test='improvements-details__webanalytics--ko'
        />
      ) : (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e =>
                e.issueType ===
                EmailMessageCheckUpIssueType.WebAnalyticsTrackingInfo
            ).silenced
          }
          icon={ICON_CHECK}
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.WebAnalyticsTrackingInfo,
              e.toLowerCase()
            )
          }
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.WebAnalyticsTrackingInfoOkTitle'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailCheckUp.WebAnalyticsTrackingInfoOkDesc'
          })}
          data-mu-test='improvements-details__webanalytics--ok'
        />
      )}
      {domainCustomizableStatus !== CUSTOM_DOMAIN_NOT_CUSTOMIZABLE && (
        <>
          {DomainCustomizable ? (
            <CheckItem
              alert={
                silencedAlertsArray.length > 0 &&
                silencedAlertsArray.find(
                  e =>
                    e.issueType ===
                    EmailMessageCheckUpIssueType.DomainCustomizable
                ).silenced
              }
              icon='info'
              callbackAlert={e =>
                changeAlert(
                  EmailMessageCheckUpIssueType.DomainCustomizable,
                  e.toLowerCase()
                )
              }
              title={intl.formatMessage({
                id: 'Load.EmailCheckUp.CustomTrackingDomainKo'
              })}
              description={intl.formatMessage(
                {
                  id: 'Load.EmailCheckUp.CustomTrackingDomainKoDescription'
                },
                {
                  link: chunks => (
                    <Link
                      key='racking-domain-Link'
                      variant={LINK_VARIANT_EXTRALIGHT}
                      onClick={() =>
                        notifyParent('redirectMainFrame', [
                          'settings_app_redirector.aspx?r=/settings/tracking-domain'
                        ])
                      }
                    >
                      {chunks}
                    </Link>
                  )
                }
              )}
              data-mu-test='improvements-details__CustomTrackingDomain--ko'
            />
          ) : (
            <CheckItem
              alert={
                silencedAlertsArray.length > 0 &&
                silencedAlertsArray.find(
                  e =>
                    e.issueType ===
                    EmailMessageCheckUpIssueType.DomainCustomizable
                ).silenced
              }
              icon='check'
              callbackAlert={e =>
                changeAlert(
                  EmailMessageCheckUpIssueType.DomainCustomizable,
                  e.toLowerCase()
                )
              }
              title={intl.formatMessage({
                id: 'Load.EmailCheckUp.CustomTrackingDomainOk'
              })}
              description={intl.formatMessage({
                id: 'Load.EmailCheckUp.CustomTrackingDomainOkDescription'
              })}
              data-mu-test='improvements-details__CustomTrackingDomain--ok'
            />
          )}
        </>
      )}
    </Panel>
  )
}

export default ImprovementsDetails
